module.exports = __webpack_public_path__ + "media/images/flags/CO-384a7e2c2d07ef729834056ca0f34834.svg";